import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let getTimeMachine: any;

export const useSMGetTime = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getTimeMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getTimeMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    getTimeMachine,
    getTimeMachineState: state,
    getTimeMachineSend: send,
  };
};
